import { useT } from '../../i18n/context'
import type { DayCountRow } from '../../types/api'

/**
 * Balkenchart ohne Library: reine div-Balken, Höhe = count/max · 100 %,
 * min-height auch für 0-Werte, title-Tooltip „Datum: n".
 * X-Beschriftung sparsam: erster/Mittelwert/letzter Tag.
 */
export function MiniBarChart({
    data,
    valueLabel = 'Anzahl',
    className = '',
}: {
    data: DayCountRow[]
    /** Einheit im Tooltip, z. B. „Registrierungen" */
    valueLabel?: string
    className?: string
}) {
    const t = useT()
    const max = Math.max(1, ...data.map(d => d.count))
    const last = data.length - 1
    const labelIndices = [
        ...new Set([0, Math.floor(last / 2), last].filter(i => i >= 0)),
    ].sort((a, b) => a - b)

    return (
        <div className={className}>
            <div
                className='flex h-32 items-end gap-px'
                role='img'
                aria-label={t('charts.barChartAria', { label: valueLabel })}
            >
                {data.map(d => (
                    <div
                        key={d.day}
                        title={`${d.day}: ${d.count} ${valueLabel}`}
                        className='flex-1 rounded-t-sm bg-indigo-600/75 transition-colors hover:bg-indigo-700'
                        style={{
                            height: `${Math.max(
                                (d.count / max) * 100,
                                d.count === 0 ? 1.5 : 4,
                            )}%`,
                        }}
                    />
                ))}
            </div>
            <div className='mt-1 flex justify-between text-[10px] leading-none text-slate-500 dark:text-slate-400'>
                {labelIndices.map(i => (
                    <span key={i}>{data[i]?.day.slice(5)}</span>
                ))}
            </div>
        </div>
    )
}
